<template>
  <nuttrema-layout-three-vertical class="is-in-mobile-ready-layout">

    <participant-standard-header
       slot="top"
       v-if="!loading"
      :meta="meta"
      :edit.sync="edit"
      :showEdit="true"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">
      <nuttrema-loader v-if="loading"></nuttrema-loader>
      <form-personal-change-email
         v-else
        :edit.sync="edit"
        :PersonalProfile="PersonalProfile"
        :PersonalEmailChange="PersonalEmailChange"
        @submit="onSubmitForm">
      </form-personal-change-email>
    </template>

  </nuttrema-layout-three-vertical>
</template>

<script>
import PageProps from 'components/mixins/page-props';
import ResponsiveMonitor from 'components/mixins/responsive-monitor';

import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';
import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';

import PagePersonalChangeEmail from 'components/pages/shared/change-email/page-personal-change-email';

export default {
  name: 'page-my-preferences',
  mixins: [
    PageProps,
    ResponsiveMonitor,
    PagePersonalChangeEmail,
  ],
  components: {
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
  },
  computed: {
    loading() {
      return this.PersonalProfile.fetching || this.PersonalEmailChange.fetching;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/participant/my-preferences/page-participant-change-email.vue